module.exports = __webpack_public_path__ + "img/RETRO_A1010.e1cbddbd.png";